import {createSelector} from 'reselect';
import {AppState} from '../../../index';

export const stateProgramSelector = () =>
  createSelector(
    (state: AppState) => state.socialSupport.statePrograms.programs,
    (item) => item,
  );
